import React from 'react';
import LoadingSpinner from './LoadingSpinner';

/**
 * Spinner with a short line of text under it, for a page or card that is loading.
 */
const LoadingMessage = ({
  message = 'Loading…',
  size = 'medium',
  color = '#e08a08',
  className = '',
  spinnerClassName = '',
  messageClassName = ''
}) => {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 py-10 ${className}`}>
      <div className={spinnerClassName}>
        <LoadingSpinner size={size} color={color} />
      </div>
      {message && (
        <p className={`text-center text-sm text-ui-ink-2 ${messageClassName}`}>
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingMessage;
